import React from 'react';
import ServiceTemplate from './ServiceTemplate';

export default function ProyectoService() {
  return <ServiceTemplate serviceName="proyecto" />;
}
